import React from 'react'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
/* import Link from '@mui/material/Link'; */
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
/* import Copyright from '../../components/Copyright/Copyright'; */
/* import Error from '../../Error/Error'; */
import { Multiselect } from 'multiselect-react-dropdown';
/* import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
 */
import { Layout, AdBlock, AdImage } from '../../../components';


const RegistroPrestadoresView = ({ formik, loading, error, zonas, servicios, acepto_terminos_y_condiciones, terminos_y_condiciones }) => {

    const theme = createTheme({
        typography: {
            fontSize: 14,
        },
        spacing: 12
    });

    return (
        <Layout background="#1f2024">
            <ThemeProvider theme={theme}>
                <Container component="main" maxWidth="md">
                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            marginBottom: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 2, bgcolor: 'primary.main', width: "60px", height: "60px" }} />

                        <Typography component="h1" variant="h5">
                            Registrarme
                        </Typography>

                        <Box component="form" noValidate onSubmit={formik.handleSubmit} sx={{ mt: 3 }}>

                            <Grid container spacing={2}>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        name="nombre"
                                        required
                                        fullWidth
                                        id="nombre"
                                        label="Ingresa tu nombre"
                                        autoFocus
                                        size="small"
                                        margin="normal"
                                        value={formik.values.nombre}
                                        onChange={formik.handleChange}
                                        error={formik.touched.nombre && formik.errors.nombre}
                                        helperText={formik.touched.nombre && formik.errors.nombre}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="apellido"
                                        label="Ingresa tu apellido"
                                        name="apellido"
                                        autoComplete="family-name"
                                        size="small"
                                        margin="normal"
                                        value={formik.values.apellido}
                                        onChange={formik.handleChange}
                                        error={formik.touched.apellido && formik.errors.apellido}
                                        helperText={formik.touched.apellido && formik.errors.apellido}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        name="dni"
                                        required
                                        fullWidth
                                        id="dni"
                                        label="Documento Nacional de Identidad"
                                        autoFocus
                                        size="small"
                                        margin="normal"
                                        value={formik.values.dni}
                                        onChange={formik.handleChange}
                                        error={formik.touched.dni && formik.errors.dni}
                                        helperText={formik.touched.dni && formik.errors.dni}
                                    />
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                <TextField
                                    required
                                    fullWidth
                                    id="cuit"
                                    label="C.U.I.T"
                                    name="cuit"
                                    autoComplete="family-name"
                                    size="small"
                                    margin="normal"
                                    value={formik.values.cuit}
                                    onChange={formik.handleChange}
                                    error={formik.touched.cuit && formik.errors.cuit}
                                    helperText={formik.touched.cuit && formik.errors.cuit}
                                />
                            </Grid> */}

                                {/*  <Grid item xs={12} md={6}>
                                <TextField
                                    autoComplete="given-name"
                                    name="razonSocial"
                                    required
                                    fullWidth
                                    id="razonSocial"
                                    label="Razon Social"
                                    autoFocus
                                    size="small"
                                    margin="normal"
                                    value={formik.values.razonSocial}
                                    onChange={formik.handleChange}
                                    error={formik.touched.razonSocial && formik.errors.razonSocial}
                                    helperText={formik.touched.razonSocial && formik.errors.razonSocial}
                                />
                            </Grid> */}

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="email"
                                        label="Correo electrónico"
                                        name="email"
                                        autoComplete="email"
                                        size="small"
                                        margin="normal"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        error={formik.touched.email && formik.errors.email}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="password"
                                        label="Contraseña"
                                        type="password"
                                        id="password"
                                        size="small"
                                        margin="normal"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        error={formik.touched.password && formik.errors.password}
                                        helperText={formik.touched.password && formik.errors.password}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="confirmar_password"
                                        label="Confirmar contraseña"
                                        type="password"

                                        size="small"
                                        margin="normal"
                                        value={formik.values.confirmar_password}
                                        onChange={formik.handleChange}
                                        /* error={formik.touched.confirmar_password && formik.errors.confirmar_password} */

                                        helperText={formik.values.confirmar_password !== '' ? formik.values.password !== formik.values.confirmar_password && 'No coinciden' : ''}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="codigo_de_area"
                                        label="Código de área"
                                        type="phone"
                                        id="codigo_de_area"
                                        size="small"
                                        margin="normal"
                                        value={formik.values.codigo_de_area}
                                        onChange={formik.handleChange}
                                        error={formik.touched.codigo_de_area && formik.errors.codigo_de_area}
                                        helperText={formik.touched.codigo_de_area && formik.errors.codigo_de_area}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="celular"
                                        label="Teléfono celular"
                                        type="phone"
                                        id="celular"
                                        size="small"
                                        margin="normal"
                                        value={formik.values.celular}
                                        onChange={formik.handleChange}
                                        error={formik.touched.celular && formik.errors.celular}
                                        helperText={formik.touched.celular && formik.errors.celular}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Multiselect
                                        placeholder="Zonas"
                                        hidePlaceholder
                                        showArrow
                                        emptyRecordMsg="No hay opciones disponibles"
                                        options={zonas}
                                        displayValue="name"
                                        onSelect={(selected) => (formik.values.zonas = selected)}
                                        onRemove={(selectedList, removedItem) => {
                                            let i = selectedList.indexOf(removedItem);
                                            if (i !== -1) selectedList.splice(i, 1);
                                            formik.values.zonas = selectedList;
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <Multiselect
                                        placeholder="Categoria laboral"
                                        hidePlaceholder
                                        showArrow
                                        emptyRecordMsg="No hay opciones disponibles"
                                        options={servicios}
                                        displayValue="name"
                                        onSelect={(selected) => (formik.values.servicios = selected)}
                                        onRemove={(selectedList, removedItem) => {
                                            let i = selectedList.indexOf(removedItem);
                                            if (i !== -1) selectedList.splice(i, 1);
                                            formik.values.servicios = selectedList;
                                        }}
                                    />

                                </Grid>

                                <Grid item xs={12} >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                value="terminos_y_condiciones"
                                                color="primary"
                                                onClick={() => {
                                                    if (terminos_y_condiciones) {
                                                        acepto_terminos_y_condiciones(false)
                                                    } else {
                                                        acepto_terminos_y_condiciones(true)
                                                    }
                                                }}
                                            />}
                                        label="Acepto terminos y condiciones."
                                    />
                                </Grid>
                            </Grid>

                            {
                                terminos_y_condiciones
                                    ? <Button
                                        type="submit"
                                        variant="contained"
                                        xs={6}
                                        sx={{ mt: 3, mb: 2 }}
                                    >
                                        Registrarme
                                    </Button>
                                    : null
                            }

                            <Grid container justifyContent="flex-end">
                                <Grid item>
                                    <Link to="/login/prestadores" >
                                        ¿Ya tenes una cuenta? Inicia Sesión
                                    </Link>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                </Container>
            </ThemeProvider>
        </Layout>
    )
}

export default RegistroPrestadoresView;
